import React, { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

import Service from "../../Service/firebase";
import firebase from "../../firebase";
import NewCategoryForm from "./newcategoryform";

import "./addcategory.css";

const AddCategory = (props) => {
  const [imageAvatar, setImageAvatar] = useState("");
  const [imageFile, setImageFile] = useState("");
  const [date, setDate] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadMoreData, setIsLoadMoreData] = useState(false);
  const [htmlElement, setHtmlElement] = useState(
    <i className="fa fa-user fa-8x" aria-hidden="true"></i>
  );
  const [formData, setFormData] = useState({
    name: "",
    categoryId: "",
    isActive: true,
  });

  const handleSubmit = () => {
    setIsLoading(true);
    props.setCloseBtnAppear();
    handleImageForUpload();
  };
  const handleImageForUpload = () => {
    const image = imageFile;
    const url = "";

    if (imageFile !== "") {
      onUploadImage(image);
    } else {
      onAddPerson(url);
    }
  };
  const onUploadImage = async (image) => {
    const url = await Service.uploadImage(image, "categoryIcons");
    if (url !== "") {
      onAddPerson(url);
    }
  };
  const onFetchSalonType = async () => {
    // Removed - salonType no longer used in category
  };
  const onAddPerson = async (imageUrl) => {
    let sendData = {
      ...formData,
      imageurl: imageUrl,
      timeStamp: firebase.firestore.Timestamp.fromDate(new Date()),
    };

    const res = await Service.addDataCategory(
      sendData,
      props.collectionName,
      props.id
    );

    if (res === "success") {
      setIsLoading(false);

      props.handleSuccessDailog();
    } else {
      setIsLoading(false);
      props.handleErrorDailog();
    }
  };

  const handleChange = (date) => {
    if (date !== null) {
      const birthDate = new Date(date);
      setDate(date);
      setFormData({
        ...formData,
      });
      setStartDate(date);
    } else {
      setDate(date);
      setFormData({
        ...formData,
      });
      setStartDate(date);
    }
  };
  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setImageFile(event.target.files[0]);
      let reader = new FileReader();
      reader.onload = (e) => {
        setImageAvatar(e.target.result);
        setHtmlElement(
          <div className="addpersonpage">
            <img
              className="netimage"
              srcSet={e.target.result}
              alt="profileImage"
            />
          </div>
        );
        reader.readAsDataURL(event.target.files[0]);
      };
    }
  };
  const onImageRemove = () => {
    setImageFile("");
    setImageAvatar("");
    setHtmlElement(
      <div className="addpersonpage">
        <i className="fa fa-user fa-8x" aria-hidden="true"></i>
      </div>
    );
  };
  const onEdit = (e) => {
    const formDataNew = formData;
    setFormData({
      ...formDataNew,
      [e.target.name]: e.target.value,
    });
  };

  // if (imageAvatar === "") {
  //   htmlElement = (
  //     <div className="addpersonpage">
  //       <i className="fa fa-user fa-8x" aria-hidden="true"></i>
  //     </div>
  //   );
  // } else {
  //   htmlElement = (
  //     <div className="addpersonpage">
  //       <img className="netimage" srcSet={imageAvatar} alt="" />
  //     </div>
  //   );
  // }
  return isLoading ? (
    <div className="addCategoryPage">
      <i className="fas fa-spinner fa-pulse fa-2x"></i>
    </div>
  ) : (
    <div className="addCategoryPage">
      <div className="container main_section">
        <div className="row">
          <div className="col-sm">
            <NewCategoryForm
              handleSubmit={handleSubmit}
              onEdit={onEdit}
              // startDate={startDate}
              date={date}
              htmlElement={htmlElement}
              handleChange={handleChange}
              onImageRemove={onImageRemove}
              onImageChange={onImageChange}
            ></NewCategoryForm>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCategory;
